<template>
  <div class="w-100 carousel-main-height-wrapper">
    <div class="container-fluid px-0 px-md-3 position-relative section-padding">
      <div class="row mr-0 mr-lg-up latest-video-content" id="radioNegeriv2">
        <div class="col-12 px-0 py-0 px-1 py-1">
          <p class="header-text text-center text-md-left">Radio Negeri</p>
        </div>
        <div
          class="col-6 col-md-4 col-lg-3 col-xl-2 p-1"
          v-for="item_vod in tv_list"
          :key="item_vod.id"
          @mouseover="mouseOver"
          @mouseout="mouseOver"
        >
          <radioCard
            :image="item_vod.image"
            :title="item_vod.title"
            :link="item_vod.redirect_url"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import radioCard from "../../../cards/v2/radioCard.vue";
import StaticListNegeri from "../../../../static/radio-negeri.json";
export default {
  data: function() {
    return {
      tv_list: [],
      hover: false,
    };
  },
  components: { radioCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    formatString(str) {
      var lower = str.toLowerCase();
      return lower
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    initializeContentForStart() {
      //for latest video
      var vm = this;
      vm.tv_list = StaticListNegeri;
      vm.tv_list.forEach((item) => {
        item["redirect_url"] = `/radio/negeri/${item.slug}`;
      });
    },
  },
  mounted() {
    setTimeout(
      function() {
        this.initializeContentForStart();
      }.bind(this),
      1000
    );
  },
};
</script>

<style scoped>
.section-padding {
  margin: 20px 8px 8px;
  height: auto !important;
}
.header-text {
  color: #fff;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 8px;
}
@media (max-width: 576px) {
  .header-text {
    font-size: 20px;
  }
}
</style>
